import React from 'react'
import ReactDOM from 'react-dom/client'
import './globals.css'
import { Toaster } from 'sonner'
import App from './App'
import './i18n/i18n'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
    <Toaster />
  </React.StrictMode>
)
